import { useTranslations } from '@vocab/react';
import { Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

import translations from './.vocab';

export const Success = ({
  contactName,
  phoneNumber,
  waitDays,
}: {
  contactName: string;
  phoneNumber: string;
  waitDays: number;
}) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="large">
      <Heading level="2">
        {t('job-ad-booking-success-heading', { contactName })}
      </Heading>
      <Text>
        {t('job-ad-booking-success-text', {
          phoneNumber,
          waitDays: waitDays.toString(),
        })}
      </Text>
    </Stack>
  );
};
